import docsUrl from '@config/docsUrl';

export default {
    en: {
        language: 'EN',
        email: 'cfiqb37k@ptengine-f3babf445873.intercom-mail.com',
        links: {
            help: 'https://help.ptx.com',
            gtm: docsUrl.gtm
        }
    },
    jp: {
        language: 'JP',
        email: 'cfiqb37k@ptengine-f3babf445873.intercom-mail.com',
        links: {
            help: 'https://help.ptx.com',
            gtm: docsUrl.gtm
        }
    },
    zh: {
        language: 'ZH',
        links: {
            help: 'https://help.ptx.com',
            gtm: docsUrl.gtm
        }
    }
};
